<template>
  <section class="underwriting-refer">
    <div
      v-if="!isFamily"
      class="table">
      <div class="tr">
        <span>Type of Insured</span>
        <span>{{ getAllOptionName27('type_of_insured', quoteForm.type_of_insured)  }}</span>
      </div>
      <div class="tr">
        <span>Age</span>
        <span>{{ quoteForm.age_id }}</span>
      </div>
      <div class="tr">
        <span>Occupation</span>
        <span>{{ getAllOptionName27('occupation', quoteForm.occ_id)  }}</span>
      </div>
    </div>
    <div
      v-else
      class="table">
      <div class="tr">
        <span>Type of Insured</span>
        <span>{{ getAllOptionName27('type_of_insured', quoteForm.type_of_insured)  }}</span>
      </div>
      <div class="tr">
        <span>Number of Insured Person(s)</span>
        <span>{{ numOfTraveller }}</span>
      </div>
      <!--      <div class="tr">-->
      <!--        <span>Occupation</span>-->
      <!--        <span>{{ getAllOptionName27('occupation', quoteForm.occ_id)  }}</span>-->
      <!--      </div>-->
    </div>
  </section>
</template>
<script>
import { mapState } from 'vuex'
import MixinOptions from '@/mixins/options'
export default {
  name: 'UnderwritingRefer',
  mixins: [MixinOptions],
  computed: {
    ...mapState('quote', ['quoteForm']),
    localAllOptions() {
      return this.allOptions27
    },
    isFamily(){
      let {type_of_insured} = this.quoteForm||{}
      return type_of_insured==2
    },
    nm_pa_list(){
      let {nm_pa_list} = this.quoteForm||{}
      return nm_pa_list||[]
    },
    numOfTraveller(){
      const { no_of_adult, no_of_child } = this.quoteForm
      const signAdult = 'Adult(s)'
      const signChild = 'Child(ren)'
      return no_of_child? `${no_of_adult} ${signAdult} · ${no_of_child} ${signChild}` : `${no_of_adult} ${signAdult}`
    },
  }
}
</script>
